import API_URLS from "@constants/apiUrls";
import { api } from "services/customBaseQuery";

export const settingsAPI = api.injectEndpoints({
  endpoints: (build) => ({
    changePassword: build.mutation<any, any>({
      query: (data) => ({
        url: API_URLS.CHANGE_PASSWORD,
        method: "POST",
        body: data,
        credentials: "include",
      }),
    }),

    updateProfile: build.mutation<any, any>({
      query: (data) => ({
        url: API_URLS.USER_PROFILE,
        method: "PATCH",
        body: data,
        credentials: "include",
      }),
    }),

    fetchProfile: build.query<any, void>({
      query: () => ({
        url: API_URLS.USER_PROFILE,
        method: "GET",
        credentials: "include",
      }),
    }),
  }),
});

export const {
  useChangePasswordMutation,
  useUpdateProfileMutation,
  useFetchProfileQuery,
  useLazyFetchProfileQuery,
} = settingsAPI;
